<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'Our Live Update SDK is open source and easy to integrate thanks to comprehensive documentation'
    "
    [icon]="'@tui.code'"
    [subtitle]="'Integration'"
    [title]="'Integrate this afternoon with our SDK'"
  >
  </app-section-header>
  <div class="w-full text-base">
    <div
      class="flex justify-between rounded-t-[--tui-radius-l] bg-[#1E1E1E] p-4"
    >
      <div class="flex flex-row items-center gap-4">
        <div class="h-3 w-3 rounded-full bg-[#FF5F56]"></div>
        <div class="h-3 w-3 rounded-full bg-[#FFBD2E]"></div>
        <div class="h-3 w-3 rounded-full bg-[#27C93F]"></div>
      </div>
      <span class="font-bold text-white">capacitor-live-update.ts</span>
      <div></div>
    </div>
    <div
      class="overflow-x-auto rounded-b-[--tui-radius-l] bg-[#121212] p-4 md:p-6"
    >
      <code class="code" [innerHTML]="code | codeToHtml | async"></code>
    </div>
  </div>
</section>
